import React from "react";

import { Stack, Text } from "@chakra-ui/react";

import { UserAvatarWithRole } from "../../../utils/chakra/AvatarWithTooltip";

import useTranslations from "../../../../hooks/useTranslations";

import { AnswerReviewProps } from "./types/AnswerReviewProps";

const AnswerFrom: React.FC<
  Omit<AnswerReviewProps, "question"> & { omit?: boolean }
> = React.memo(({ answer, path, omit }) => {
  const t = useTranslations();

  if (omit) return null;

  return (
    <Stack spacing="4" direction="row" alignItems="center">
      <UserAvatarWithRole
        src={answer.user.avatar}
        name={answer.user.name}
        role={
          answer.isCollaborator
            ? (t("reports.shared.role.collaborator") as string)
            : (t("reports.shared.role.referent") as string)
        }
        rootProps={{
          avatarProps: {
            size: "sm",
          },
        }}
      />
      <Text
        as="label"
        htmlFor={`${path}.answer.${answer.id}.value`}
        color="gray.600"
        fontWeight="medium"
        fontSize="md"
      >
        {t("reports.shared.answerOf", { name: answer.user.name })}
      </Text>
    </Stack>
  );
});

export default AnswerFrom;
